export enum CustomerPortalAcessEnum{
    None=0,
    PortalOn=1,
    PortalOff=2,
    ResourceOnly=3
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/security/customer-portal-acess.enum.ts